<div class="d-flex justify-content-center">
  <div class="card" [style.background-color]="clozeTestStyleModel().exerciseBackground"
    [style.border]="mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor"
    [style.border-radius]="mobileMode() ? '0' : '8px'" [style.width]="mobileMode() ? '100%' : '720px'">
    <div class="card-body p-4">

      @if (lang().toLowerCase() === 'de') {
      <div class="card-title-row">
        <h4 class="card-title">Herzlich Willkommen!</h4>
      </div>

      <div>
        <p class="mb-3">Der Spracheinstufungstest dauert maximal 20 Minuten. Um ein valides Ergebnis zu erhalten, bearbeitest du ihn
          selbstständig und in einem ruhigen Raum.</p>
        <p class="mb-3">In den folgenden Texten fehlen bei einer Reihe von Wörtern jeweils einige Buchstaben. Ergänze bitte die
          Lücken in sinnvoller Weise. Du hast für jeden Text maximal 5 Minuten Zeit.</p>
        <p class="mb-3">Wenn du Umlaute (ä, ö, ü) brauchst und diese nicht auf deiner Tastatur findest, klicke einfach auf den
          richtigen Umlaut im Fenster unten. Verwende keine Kombination wie "ae" oder "ue" oder "oe".</p>
        <p class="mb-3">Dieser Teil ist beendet, wenn du den letzten Text 5 Minuten lang bearbeitet hast oder auf "Test beenden"
          klickst.</p>
        <p class="mb-3">Klicke nun auf "Weiter", um den ersten Text zu bearbeiten.</p>
        <p class="mb-0"><strong>Hinweis:</strong><br />Je nach Gerät kann die Darstellung des Sprachtests variieren.
          Wenn der Text für dich unscharf oder schwer lesbar ist, versuche es bitte mit einem neueren Gerät oder einem
          Computer.</p>
      </div>
      }
      @if (lang().toLowerCase() === 'en') {
      <div class="card-title-row">
        <h4 class="card-title">Welcome!</h4>
      </div>

      <div>
        <p class="mb-3">The language placement test takes a maximum of 20 minutes. To get a valid result, work through
          it alone and in a quiet room.</p>
        <p class="mb-3">In the following texts, several letters are missing from a number of words. Please fill in the
          gaps in a meaningful way. You have a maximum of 5 minutes for each text.</p>
        <p class="mb-3">This part is finished when you have edited the last text for 5 minutes or click "End test".</p>
        <p class="mb-3">Now click on "Continue" to edit the first text.</p>
        <p class="mb-0"><strong>Please note:</strong><br />The way the language test is displayed may vary depending on
          your device. If the text appears blurry or is difficult to read, please try using a newer device or a
          computer.</p>
      </div>
      }

      <div class="d-flex justify-content-end mt-3">
        <button class="btn" style="font-size: smaller" [style.background-color]="clozeTestStyleModel().buttonsColor" (click)="onStartTest()">
          {{ lang().toLowerCase() === 'de' ? 'Weiter' : 'Continue' }}
          <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>

    </div>
  </div>
</div>